import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { useState } from 'react'

import { IntervalsEditor } from '../intervals_editor'

// i18n-tasks-use t('publisher.availability.schedules.weekday_popup.title.#{day}')
export default ({ day, intervals, onClose, setWdayIntervals }) => {
  const [newInts, setNewInts] = useState(intervals)

  const onConfirm = () => {
    if (newInts.some(({ error }) => error)) return
    setWdayIntervals(day, newInts)
    onClose()
  }

  return (
    <SimplePopup
      onConfirm={onConfirm}
      onClose={onClose}
      title={I18n.t(`publisher.availability.schedules.weekday_popup.title.${day}`)}
      cancelLabel={I18n.t('publisher.action.cancel')}
      confirmLabel={I18n.t('publisher.action.apply')}
    >
      <IntervalsEditor intervals={newInts} setIntervals={setNewInts} />
    </SimplePopup>
  )
}
